(() => {
  if (window.rhodiVideoLoadingInitialized) return;
  window.rhodiVideoLoadingInitialized = true;

  const initialize = (root) => {
    if (!('IntersectionObserver' in window) || navigator.connection?.saveData) return;

    root.querySelectorAll('[data-rhodi-video-gallery]').forEach((gallery) => {
      if (gallery.dataset.loadingInitialized) return;
      gallery.dataset.loadingInitialized = 'true';

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(({ target: video, isIntersecting }) => {
          if (!isIntersecting) return;
          observer.unobserve(video);
          video.preload = 'metadata';
          if (video.paused && video.readyState === 0) video.load();
        });
      }, { rootMargin: '300px 0px', threshold: 0.01 });

      const observeVideos = (root) => {
        if (root.matches?.('video')) observer.observe(root);
        root.querySelectorAll?.('video').forEach((video) => observer.observe(video));
      };
      observeVideos(gallery);
      const additions = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => mutation.addedNodes.forEach(observeVideos));
      });
      additions.observe(gallery, { childList: true, subtree: true });
      gallery.addEventListener('rhodi:video-gallery-unload', () => {
        observer.disconnect();
        additions.disconnect();
      }, { once: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-rhodi-video-gallery]').forEach((gallery) => {
      gallery.dispatchEvent(new Event('rhodi:video-gallery-unload'));
    });
  });
})();
